import { CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

const Toast = ({ visible, type = "success", message, onClose, animationClass }) => {
    if (!visible) return null;

    const colorMap = {
        success: { border: "border-l-[#2D7D46]", icon: "text-green-600", title: "Success", maxWidth: "max-w-[360px]" },
        error: { border: "border-l-red-600", icon: "text-red-600", title: "Error", maxWidth: "max-w-[480px]" },
        warning: { border: "border-l-yellow-500", icon: "text-yellow-600", title: "Warning", maxWidth: "max-w-[480px]" }
    };

    const { border, icon, title, maxWidth } = colorMap[type] || colorMap.success;

    return (
        <div style={{ zIndex: 2147483647 }}
            className={`fixed top-6 right-6 z-[999] bg-white p-4
                shadow-[0_6px_24px_rgba(0,0,0,0.2),0_0_10px_rgba(0,0,0,0.1)] 
                border-l-[6px] ${border} ${maxWidth} ${animationClass}`}
        >
            <div className="flex justify-between items-start">
                <div className="flex items-start">
                    {type === 'success' && <CheckCircle className={`h-6 w-6 ${icon} mr-3 mt-1`} />}
                    {type === 'error' && <XCircle className={`h-6 w-6 ${icon} mr-3 mt-1`} />}
                    {type === 'warning' && <AlertTriangle className={`h-6 w-6 ${icon} mr-3 mt-1`} />}
                    <div>
                        <div className="text-gray-800 text-base font-semibold">{title}</div>
                        <div
                            className="text-gray-600 text-base font-normal pt-1 pb-2"
                            dangerouslySetInnerHTML={{ __html: message }}
                        />
                    </div>

                </div>
                <button onClick={onClose} className="text-gray-500 hover:text-gray-700 ml-4" aria-label="Close">
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default Toast;